export const SENSITIVE = 'sensitive';
export const HIGHLY_SENSITIVE = 'highly_sensitive';
export const V2_SENSITIVE = 'v2';